import React from 'react';
import { ShieldCheckIcon, TruckIcon, WrenchIcon, CheckIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
import { products } from '../../data/products';
export function ProductComparison() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <div className="space-y-12" data-id="element-484">
      {/* Comparison Table */}
      <div className="relative overflow-x-auto rounded-2xl border border-dark-border bg-dark-surface/80 backdrop-blur-sm shadow-xl custom-scrollbar" data-id="element-485">
        <table className="w-full text-left border-collapse min-w-[900px]" data-id="element-486">
          <thead data-id="element-487">
            <tr data-id="element-488">
              {/* Sticky Top-Left Empty Cell */}
              <th className="sticky left-0 z-20 bg-dark-surface/95 backdrop-blur border-b border-r border-dark-border p-6 w-48 align-bottom" data-id="element-489">
                <span className="text-xs font-bold tracking-widest text-gray-500 uppercase" data-id="element-490">
                  {en ? 'Specifications' : ru ? 'Характеристики' : 'Specifikacije'}
                </span>
              </th>

              {/* Product Headers */}
              {products.map(product => {
              const isHero = product.id === 'raptor';
              return <th key={product.id} className={`relative p-6 border-b border-dark-border min-w-[220px] align-top ${isHero ? 'bg-brand-yellow/5' : ''}`} data-id="element-491">
                    {isHero && <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-brand-yellow text-dark-bg text-[10px] font-black uppercase tracking-widest px-3 py-1 rounded-b-md whitespace-nowrap" data-id="element-492">
                        {en ? 'Recommended' : ru ? 'Рекомендуем' : 'Preporuka'}
                      </div>}

                    <div className="text-center mt-4" data-id="element-493">
                      <h3 className={`text-xl font-black tracking-tight ${isHero ? 'text-brand-yellow' : 'text-white'}`} data-id="element-494">
                        {product.name}
                      </h3>
                      <p className={`text-xs uppercase tracking-widest mt-1 font-bold ${isHero ? 'text-brand-yellow/80' : 'text-brand-yellow/70'}`} data-id="element-495">
                        {product.model}
                      </p>

                      <div className="mt-4" data-id="element-496">
                        {product.priceLabel ? <span className="bg-gradient-to-r from-brand-yellow via-yellow-200 to-brand-yellow text-dark-bg animate-shine font-black text-xs tracking-widest uppercase px-3 py-1 rounded-full shadow-[0_0_15px_rgba(253,185,19,0.4)] whitespace-nowrap border border-yellow-300 inline-block" data-id="element-497">
                            {lang === 'en' && product.priceLabelEn ? product.priceLabelEn : lang === 'ru' && product.priceLabelRu ? product.priceLabelRu : product.priceLabel}
                          </span> : <div data-id="element-498">
                            <p className={`text-2xl font-black ${isHero ? 'text-brand-yellow' : 'text-white'}`} data-id="element-499">
                              €{product.price.toLocaleString()}
                            </p>
                            <p className="text-[10px] text-gray-500 mt-0.5 uppercase tracking-wider" data-id="element-500">
                              {en ? 'excl. VAT' : ru ? 'без НДС' : 'bez PDV'}
                            </p>
                          </div>}
                      </div>
                    </div>
                  </th>;
            })}
            </tr>
          </thead>
          <tbody className="divide-y divide-dark-border" data-id="element-501">
            {/* Capacity Row */}
            <tr data-id="element-502">
              <td className="sticky left-0 z-10 bg-dark-surface/95 backdrop-blur border-r border-dark-border p-4 text-xs font-bold uppercase tracking-wider text-gray-400" data-id="element-503">
                {en ? 'Capacity' : ru ? 'Грузоподъёмность' : 'Nosivost'}
              </td>
              {products.map(product => <td key={product.id} className={`p-4 text-sm font-semibold text-white text-center ${product.id === 'raptor' ? 'bg-brand-yellow/5' : ''}`} data-id="element-504">
                  {product.specs.capacity}
                </td>)}
            </tr>

            {/* Motor Row */}
            <tr data-id="element-505">
              <td className="sticky left-0 z-10 bg-dark-surface/95 backdrop-blur border-r border-dark-border p-4 text-xs font-bold uppercase tracking-wider text-gray-400" data-id="element-506">
                {en ? 'Motor' : ru ? 'Двигатель' : 'Motor'}
              </td>
              {products.map(product => <td key={product.id} className={`p-4 text-sm font-semibold text-white text-center ${product.id === 'raptor' ? 'bg-brand-yellow/5' : ''}`} data-id="element-507">
                  {product.specs.motor}
                </td>)}
            </tr>

            {/* Battery Row */}
            <tr data-id="element-508">
              <td className="sticky left-0 z-10 bg-dark-surface/95 backdrop-blur border-r border-dark-border p-4 text-xs font-bold uppercase tracking-wider text-gray-400" data-id="element-509">
                {en ? 'Battery' : ru ? 'Аккумулятор' : 'Baterija'}
              </td>
              {products.map(product => <td key={product.id} className={`p-4 text-sm font-semibold text-white text-center ${product.id === 'raptor' ? 'bg-brand-yellow/5' : ''}`} data-id="element-510">
                  {lang === 'en' && product.specs.batteryEn ? product.specs.batteryEn : lang === 'ru' && product.specs.batteryRu ? product.specs.batteryRu : product.specs.battery}
                </td>)}
            </tr>

            {/* Weight Row */}
            <tr data-id="element-511">
              <td className="sticky left-0 z-10 bg-dark-surface/95 backdrop-blur border-r border-dark-border p-4 text-xs font-bold uppercase tracking-wider text-gray-400" data-id="element-512">
                {en ? 'Weight' : ru ? 'Вес' : 'Težina'}
              </td>
              {products.map(product => <td key={product.id} className={`p-4 text-sm font-semibold text-white text-center ${product.id === 'raptor' ? 'bg-brand-yellow/5' : ''}`} data-id="element-513">
                  {product.specs.weight}
                </td>)}
            </tr>

            {/* Key Features Row */}
            <tr data-id="element-514">
              <td className="sticky left-0 z-10 bg-dark-surface/95 backdrop-blur border-r border-dark-border p-4 text-xs font-bold uppercase tracking-wider text-gray-400 align-top pt-6" data-id="element-515">
                {en ? 'Key Features' : ru ? 'Особенности' : 'Karakteristike'}
              </td>
              {products.map(product => <td key={product.id} className={`p-4 align-top ${product.id === 'raptor' ? 'bg-brand-yellow/5' : ''}`} data-id="element-516">
                  <ul className="space-y-3" data-id="element-517">
                    {(lang === 'en' && product.highlightsEn ? product.highlightsEn : lang === 'ru' && product.highlightsRu ? product.highlightsRu : product.highlights).map((highlight, idx) => <li key={idx} className="flex items-start gap-2 text-left" data-id="element-518">
                        <CheckIcon className="w-4 h-4 text-brand-yellow flex-shrink-0 mt-0.5" data-id="element-519" />
                        <span className="text-sm text-gray-300 leading-tight" data-id="element-520">
                          {highlight}
                        </span>
                      </li>)}
                  </ul>
                </td>)}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Notes */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-521">
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-522">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-523">
            <ShieldCheckIcon className="w-4 h-4 text-brand-yellow" data-id="element-524" />
          </div>
          <div data-id="element-525">
            <p className="text-sm text-gray-300" data-id="element-526">
              {en ? <>
                  Factory warranty of{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-527">
                    one year
                  </span>{' '}
                  for all legal entities.
                </> : ru ? <>
                  Заводская гарантия{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-528">
                    один год
                  </span>{' '}
                  для всех юридических лиц.
                </> : <>
                  Fabrička garancija{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-529">
                    godinu dana
                  </span>{' '}
                  za sva pravna lica.
                </>}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-530">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-531">
            <WrenchIcon className="w-4 h-4 text-brand-yellow" data-id="element-532" />
          </div>
          <div data-id="element-533">
            <p className="text-sm text-gray-300" data-id="element-534">
              {en ? 'Network of expert service technicians, original parts and operational training.' : ru ? 'Сеть квалифицированных сервисных специалистов, оригинальные запчасти и обучение работе.' : 'Mreža stručnih servisera, originalni delovi i obuka za rad.'}
            </p>
          </div>
        </div>
        <div className="flex items-start gap-3 bg-dark-surface/60 border border-dark-border/40 rounded-xl px-5 py-4" data-id="element-535">
          <div className="w-8 h-8 rounded-full bg-brand-yellow/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-536">
            <TruckIcon className="w-4 h-4 text-brand-yellow" data-id="element-537" />
          </div>
          <div data-id="element-538">
            <p className="text-sm text-gray-300" data-id="element-539">
              {en ? <>
                  Delivery in{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-540">
                    4–8 weeks
                  </span>{' '}
                  directly from production.
                </> : ru ? <>
                  Поставка за{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-541">
                    4–8 недель
                  </span>{' '}
                  напрямую с производства.
                </> : <>
                  Isporuka od{' '}
                  <span className="text-brand-yellow font-semibold" data-id="element-542">
                    4–8 nedelja
                  </span>{' '}
                  direktno iz proizvodnje.
                </>}
            </p>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <p className="text-[11px] text-gray-600 leading-relaxed text-center max-w-2xl mx-auto" data-id="element-543">
        {en ? 'Note: The stated capacity is designed for optimal operation and motor longevity. Constant overloading above the upper limit is not recommended.' : ru ? 'Примечание: Указанная грузоподъёмность рассчитана на оптимальную работу и долговечность мотора. Постоянная перегрузка выше верхнего предела не рекомендуется.' : 'Napomena: Navedena nosivost je projektovana za optimalan rad i dugovečnost motora. Ne preporučuje se konstantno preopterećenje preko gornje granice.'}
      </p>
    </div>;
}